import { DeviceUtils } from './utils';

class Statistics {
    constructor() {
        this.initCounters();
    }

    initCounters() {
        const items = document.querySelectorAll('.stats .stat .value');
        if (!items.length) {
            return;
        }

        items.forEach((item) => {
            item.dataset.value = item.textContent;
            item.textContent = 0;
        });

        const isMobileDevice = DeviceUtils.isMobileDevice();
        const delay = isMobileDevice ? 1000 : 0;

        setTimeout(() => {
            this.setScrollTrigger(items);
        }, delay);
    }

    setScrollTrigger(items) {
        ScrollTrigger.batch('.stats', {
            // markers: true,
            onEnter: (elements) => {
                if (this.numbersCounted) {
                    return;
                }
                this.numbersCounted = true;

                elements.forEach((element) => {
                    gsap.to(items, {
                        textContent: (_, target) => target.dataset.value,
                        duration: 3,
                        ease: 'Power1.easeInOut',
                        snap: { textContent: 1 },
                        stagger: {
                            each: 0,
                            onUpdate: function () {
                                this.targets()[0].innerHTML = Math.ceil(this.targets()[0].textContent);
                            }
                        },

                        onComplete: () => {
                            element.classList.add('completed');
                        }
                    });
                });
            },
            start: 'top 80%',
            end: 'bottom top'
        });
    }
}
new Statistics();
